<template>
	<div>
		<h1>Paramètres des visualisateurs</h1>

		<div id="jsoneditor"></div>
		<b-button @click="save">Mettre à jour</b-button>
	</div>
</template>

<script>
	import { JSONEditor } from "@json-editor/json-editor";

	import store from "../store";
	import users from "../services/users.js";
	import client from "../services/client.js";
	import projects from "../services/projects.js";

	export default {
		name: "viewver_prams",
		data() {
			return {
				list_projects: [],
				list_projects_libelle: {},
				list_projects_uid: {},
			};
		},
		methods: {
			async save() {
				await client.put(
					null,
					null,
					null,
					null,
					null,
					null,
					this.client.details.viewver
				);

				this.$notify({
					group: "info",
					title: "Configuration sauvegardé",
					type: "success",
				});
			},
			getProjects: async function () {
				try {
					this.list_projects = await projects.getAll(true);

					this.list_obj_projects_libelle = {};
					this.list_obj_projects_uid = {};
					this.list_projects_libelle = [];

					for (var i = 0; i < this.list_projects.length; i++) {
						if (this.list_projects[i].libelle) {
							this.list_obj_projects_libelle[
								this.list_projects[i].libelle
							] = this.list_projects[i].uid;
							this.list_obj_projects_uid[
								this.list_projects[i].uid
							] = this.list_projects[i].libelle;
							this.list_projects_libelle.push(
								this.list_projects[i].libelle
							);
						}
					}
				} catch (error) {
					console.log(error);
				}
			},
		},
		created: async function () {
			var self = this;

			if (
				store.state.user.rules &&
				!store.state.user.rules.viewver_params
			) {
				this.$router.push({ name: "profile" });
			}

			let response = await users.getSelf(true);
			this.client = response.client;

			await this.getProjects();

			var schema = {
				title: "Paramètres",
				type: "array",
				items: {
					title: "Visualisateur",
					type: "object",
					properties: {
						name: {
							type: "string",
							title: "Nom",
						},
						type: {
							type: "string",
							title: "Type",
							enum: ["db"],
							default: "db",
						},
						type_doc: {
							type: "string",
							title: "Type de document",
							enum: ["xml"],
							default: "xml",
						},
						project: {
							title: "Projet",
							type: "string",
							enum: this.list_projects_libelle,
							default: "",
						},
						project_uid: {
							type: "string",
							options: { hidden: true },
						},
						db: {
							type: "string",
							title: "Table",
						},
						filter: {
							type: "string",
							title: "Colonne des filtres",
						},
						default_filter: {
							type: "string",
							title: "Valeur du filtre par défaut",
						},
						column_url: {
							type: "string",
							title: "Colonne des urls",
						},
						column_name: {
							type: "string",
							title: "Colonne des noms des fichiers",
						},
						column_pdf: {
							type: "string",
							title: "Colonne des pdf",
						},
					},
				},
			};

			const element = document.getElementById("jsoneditor");

			this.editor = new JSONEditor(element, {
				schema: schema,
				keep_oneof_values: false,
				theme: "bootstrap4",
				object_background: "",
				iconlib: "fontawesome5",
				prompt_before_delete: false,
			});

			await new Promise((resolve, reject) => {
				self.editor.on("ready", function () {
					if (resolve) resolve();
				});
			});

			if (this.client.details.viewver)
				this.editor.setValue(this.client.details.viewver);

			this.editor.on("change", function () {
				self.client.details.viewver = self.editor.getValue();

				for (var i = 0; i < self.client.details.viewver.length; i++) {
					if (self.client.details.viewver[i].project)
						self.client.details.viewver[i].project_uid =
							self.list_obj_projects_libelle[
								self.client.details.viewver[i].project
							];
					else self.client.details.viewver[i].project_uid = "";
				}
			});
		},
	};
</script>

<style></style>
